module.exports = __webpack_public_path__ + "static/media/DianaConnolly_Pill_Shadow.c951880b.jpg";